import "./GoldenButton.css";

export default function GoldenButton(props) {
    return <></>;
}

